<script>
    let invalidForm = false;
    let loadingRequest = false;
    let waitingRequest = false;
    let requestFailed = null;
    let connectionFailed = null;
    let submitSuccessfull = null;
    let dataTable = [];

    let headersTransactionType = {
        "MATERIAL_LEAVE": "Saída de material",
        "MATERIAL_ENTRANCE": "Entrada de material",
        "STOCK_TRANSFER": "Pedido de transferência de estoque",
        "STOCK_TRANSFER_RECORDS": "Transferência de estoque"
    };

    let headersStatus = {
        "ERROR": "Erro",
        "SUCCESS": "Sucesso",
        "PENDING": "Pendente",
        "RUNNING": "Em processamento"
    };

    import API from "../services/Api";

    let submit = async (e) => {
        e.preventDefault();

        waitingRequest = true;

        let formData = new FormData();
        let inputFile = document.querySelector('#inputFile');
        formData.append('file', inputFile.files[0]);
        formData.append('user', sessionStorage.getItem('user'));

        await API.post("sap/importrecords", formData, {
            Headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(async (response) => {
                if (!response.data) {
                    waitingRequest = false;
                    return;
                }
                waitingRequest = false;
            })
            .catch((response) => {
                waitingRequest = false;
            });
    };

    let pesquisar = async () => {
        waitingRequest = true;

        await API.get("sap/importrecords")
            .then((response) => {
                dataTable = response.data;
                waitingRequest = false;
            })
            .catch((err) => {
                if (err.response) {
                    switch (err.response.status) {
                        case 404:
                            ticketNotFound = true;
                            break;
                        case 500:
                            requestFailed = true;
                            break;
                    }
                } else {
                    connectionFailed = true;
                }
                waitingRequest = false;
            });
    };
</script>

<main>
    <div class="">
        <div class="card-body">
            {#if !waitingRequest}

                <div class="input-group mb-3">
                    <input
                        type="file"
                        id="inputFile"
                        placeholder="Insira a planilha"
                        class="form-control"
                    />
                    <div class="input-group-append">
                        <button
                            class="btn btn-outline-secondary"
                            on:click={submit}
                        >
                            Importar registros
                        </button>
                    </div>
                </div>
            {:else}
                <div class=""><span>Aguarde...</span></div>
            {/if}

            {#if submitSuccessfull}
                <div
                    class="alert alert-success d-flex align-items-center"
                    role="alert"
                >
                    <svg class="bi flex-shrink-0 me-2" width="24" height="24"
                        ><use xlink:href="#check-circle-fill" /></svg
                    >
                    <div>Solicitação realizada com sucesso!</div>
                </div>
            {/if}

            {#if requestFailed}
                <div class="text-danger text-center">
                    Não foi possível realizar a pesquisa.<br />
                    Tente novamente em instantes!
                </div>
            {/if}

            {#if connectionFailed}
                <div class="text-danger text-center">
                    Houve falha de comunicação com o servidor.<br />
                    Tente novamente em instantes!
                </div>
            {/if}

        </div>
    </div>
</main>

<div class="">
    <div class="card" style="width: 100%">
        <div class="card-body">

            <div class="mb-3">
                <div class="card-title">Últimas importações</div>
            </div>

            <div class="mb-3">
                <button
                            class="btn btn-outline-secondary"
                            on:click={pesquisar}
                        >
                            Consultar dados
                        </button>
            </div>

            <table class="table table-sm">
                <thead>
                    <tr>
                        <th>Tipo de transação</th>
                        <th>Status</th>
                        <th>Resposta</th>
                        <th>Arquivo</th>
                        <th>Usuário</th>
                        <th>Data de importação do arquivo</th>
                        <th>Data de envio pro SAP</th>
                    </tr>
                </thead>
                <tbody>
                    {#each dataTable as data}
                    {#if data.status == 'ERROR'}
                    <tr class="table-danger">
                        <td>{headersTransactionType[data.type]}</td>
                        <td>{headersStatus[data.status]}</td>
                        <td>{data.response || '-'}</td>
                        <td>{data.filename || '-'}</td>
                        <td>{data.username || '-'}</td>
                        <td>{new Date(data.created_at).toLocaleString('pt-BR')}</td>
                        <td>{new Date(data.updated_at).toLocaleString('pt-BR')}</td>
                    </tr>
                    {:else}
                    <tr>
                        <td>{headersTransactionType[data.type]}</td>
                        <td>{headersStatus[data.status]}</td>
                        <td>{data.response || '-'}</td>
                        <td>{data.filename || '-'}</td>
                        <td>{data.username || '-'}</td>
                        <td>{new Date(data.created_at).toLocaleString('pt-BR')}</td>
                        <td>{new Date(data.updated_at).toLocaleString('pt-BR')}</td>
                    </tr>
                    {/if}
                    {/each}
                </tbody>
            </table>
        </div>
    </div>
</div>

<style>
    main {
        display: flex;
        flex-direction: column;
        /*height: 100%;*/
        /*min-height: 100%;*/
        /*justify-content: center;*/
        align-items: center;
    }

    .container {
        display: flex;
        flex-direction: column;
        /*justify-content: center;*/
        align-items: center;
    }

    .card {
        min-width: 350px;
    }
</style>
